<div class="modal-container" [ngClass]="{'open': show, 'close': !show}">
  <div class="modal-header text-center" [ngClass]="{'bigger-header': logo}">

    <img id="img_logo" src="./assets/img/logo-1x.png" class="modal-logo" [ngClass]="{'hide': !logo}" alt="Itaú logo" />
    <img id="img_logo" src="./assets/img/itau-text-white.png" class="modal-logo-title" [ngClass]="{'hide': !logo}" alt="Itaú logo" />
    <h2 class="modal-title text-center" [ngClass]="{'hide': logo}">{{title}}</h2>

    <div class="btn-container">
      <button class="btn-close" (click)="closeModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

  </div>

  <div class="modal-content">
    <ng-content></ng-content>
 </div>
</div>